module.exports = __webpack_public_path__ + "img/purple.f3d1c0e9.png";